import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    marginTop: theme.spacing(2),
    position: 'relative',
    height: '300px',
  },

  table: {
    '& td, & th': {
      borderTop: '1px solid rgba(224, 224, 224, 1)',
      textAlign: 'center',
      padding: theme.spacing(1),
    },
  },

  addAssociationRow: {
    width: '100%',
  },

  button: {
    margin: theme.spacing(2, 0),
    '& span': {
      margin: 0,
    },
  },
}));

export default useStyles;
